module.exports = __webpack_public_path__ + "static/media/c14.5b48ddee.png";